import store from '@state/store'

export default [
  // {
  //   path: '/',
  //   name: 'home',
  //   redirect: '/field',
  //   meta: {
  //     authRequired: true
  //   },
  //   props: (route) => ({ user: store.state.auth.currentUser || {} })
  // },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/account/user/profile')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/account',
    name: 'account',
    component: () => lazyLoadView(import('@views/account/client/clientList')),
    meta: {
      authRequired: true,
      priv: 1,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/account/detail/:id',
    name: 'account-detail',
    component: () =>
      lazyLoadView(import('@views/account/client/clientDetails')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/account/create',
    name: 'account-create',
    component: () => lazyLoadView(import('@views/account/user/userList')),
    meta: {
      authRequired: true,
      priv: 2,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/account/log-activity',
    name: 'account-log',
    component: () => lazyLoadView(import('@views/account/log/logActivity')),
    meta: {
      authRequired: true,
      priv: 3,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/comparison-study',
    name: 'comparison-study',
    component: () => lazyLoadView(import('@views/comparison/study')),
    meta: {
      authRequired: true,
      priv: 4,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  // REPORT START
  {
    path: '/report/daily-drilling-report',
    name: 'report-daily-drilling-report',
    component: () =>
      lazyLoadView(import('@views/report/daily-drilling-report')),
    meta: {
      authRequired: true,
      priv: 5,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  // DRILLING ACTIVITY START
  {
    path: '/report/drilling-activity/casing',
    name: 'report-drilling-activity-casing',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/casing')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/report/drilling-activity/kick',
    name: 'report-drilling-activity-kick',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/kick')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/report/drilling-activity/cement',
    name: 'report-drilling-activity-cement',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/cement')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/report/drilling-activity/coring',
    name: 'report-drilling-activity-coring',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/coring')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/report/drilling-activity/logging',
    name: 'report-drilling-activity-logging',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/logging')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/report/drilling-activity/fishing',
    name: 'report-drilling-activity-fishing',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/fishing')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/report/drilling-activity/well-test',
    name: 'report-drilling-activity-well-test',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/well-test')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/report/drilling-activity/general-work',
    name: 'report-drilling-activity-general-work',
    component: () =>
      lazyLoadView(import('@views/report/drilling-activity/general-work')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  // REPORT END
  {
    path: '/database/daily-drilling-report',
    name: 'database-daily-drilling-report',
    component: () =>
      lazyLoadView(import('@views/database/daily-drilling-report')),
    meta: {
      authRequired: true,
      priv: 5,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  // DRILLING ACTIVITY START
  {
    path: '/database/drilling-activity/casing',
    name: 'database-drilling-activity-casing',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/casing')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/database/drilling-activity/kick',
    name: 'database-drilling-activity-kick',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/kick')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/database/drilling-activity/cement',
    name: 'database-drilling-activity-cement',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/cement')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/database/drilling-activity/coring',
    name: 'database-drilling-activity-coring',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/coring')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/database/drilling-activity/logging',
    name: 'database-drilling-activity-logging',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/logging')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/database/drilling-activity/fishing',
    name: 'database-drilling-activity-fishing',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/fishing')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/database/drilling-activity/well-test',
    name: 'database-drilling-activity-well-test',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/well-test')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/database/drilling-activity/general-work',
    name: 'database-drilling-activity-general-work',
    component: () =>
      lazyLoadView(import('@views/database/drilling-activity/general-work')),
    meta: {
      authRequired: true,
      priv: 6,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  // DRILLING ACTIVITY END
  /* {
    path: '/database/subsurface',
    name: 'database-subsurface',
    component: () => lazyLoadView(import('@views/database/subsurface')),
    meta: {
      authRequired: true,
      priv: 7,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  }, */
  {
    path: '/database/planner',
    name: 'database-planner',
    component: () => lazyLoadView(import('@views/database/planner')),
    meta: {
      authRequired: true,
      priv: 8,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/',
    name: 'home',
    redirect: '/field/well',
    component: () => lazyLoadView(import('@views/field/tabs')),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: '/field/:tab',
        name: 'field',
        meta: {
          authRequired: true,
        },
        props: (route) => ({
          user: store.state.auth.currentUser || {},
        }),
      },
    ],
  },
  {
    path: '/dashboard/bit-performance',
    name: 'bit-performance',
    component: () =>
      lazyLoadView(import('@views/dashboard/bit-performance.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/bit-performance-cpf-mse',
    name: 'bit-performance-cpf-mse',
    component: () =>
      lazyLoadView(import('@views/dashboard/bit-performance/cpf-mse.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-program',
    name: 'drilling-program',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-program.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-progress/summary',
    name: 'drilling-progress-summary',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-progress-summary.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-progress/activity-breakdown',
    name: 'drilling-progress-activity-breakdown',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-progress.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/activity-breakdown',
    name: 'activity-breakdown',
    component: () =>
      lazyLoadView(import('@views/dashboard/activity-breakdown')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/cost-breakdown/afe-vs-actual',
    name: 'afe-vs-actual',
    component: () =>
      lazyLoadView(import('@views/dashboard/cost-breakdown/afe-vs-actual')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/cost-breakdown/cum-cost-per-contract-category',
    name: 'cum-cost-per-contract-category',
    component: () =>
      lazyLoadView(
        import('@views/dashboard/cost-breakdown/cum-cost-per-contract-category')
      ),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  }, //
  {
    path: '/dashboard/cost-breakdown/progress-cost',
    name: 'progress-cost',
    component: () =>
      lazyLoadView(import('@views/dashboard/cost-breakdown/afe-vs-actual')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-performance/activity-breakdown',
    name: 'drilling-performance-activity-breakdown',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-performance/activity-breakdown.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-performance/npt-breakdown',
    name: 'drilling-performance-npt-breakdown',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-performance/npt-breakdown.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-performance/drilling-phase-breakdown',
    name: 'drilling-performance-drilling-phase-breakdown',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-performance/drilling-phase-breakdown.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-performance/equipment-failure-breakdown',
    name: 'drilling-performance-equipment-failure-breakdown',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-performance/equipment-failure-breakdown.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-performance/npt-hole-section',
    name: 'drilling-performance-npt-hole-section',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-performance/npt-hole-section.vue')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-parameters',
    name: 'drilling-parameters',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-parameters')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/one-page',
    name: 'one-page',
    component: () =>
      lazyLoadView(import('@views/dashboard/one-page')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard',
    name: 'well-selected',
    component: () => lazyLoadView(import('@views/dashboard/well-information')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/bit-performance-field',
    name: 'bit-performance-field',
    component: () =>
      lazyLoadView(import('@views/dashboard/bit-performance-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-program-field',
    name: 'drilling-program-field',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-program-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/activity-breakdown-field',
    name: 'activity-breakdown-field',
    component: () =>
      lazyLoadView(import('@views/dashboard/activity-breakdown-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/cost-breakdown/afe-vs-actual-field',
    name: 'afe-vs-actual-field',
    component: () =>
      lazyLoadView(import('@views/dashboard/cost-breakdown/afe-vs-actual-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/cost-breakdown/progress-cost-field',
    name: 'progress-cost-field',
    component: () =>
      lazyLoadView(import('@views/dashboard/cost-breakdown/progress-cost-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/timeline-progress-field',
    name: 'timeline-progress-field',
    component: () =>
      lazyLoadView(import('@views/dashboard/cost-breakdown/timeline-progress-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/drilling-parameters-field',
    name: 'drilling-parameters-field',
    component: () =>
      lazyLoadView(import('@views/dashboard/drilling-parameters-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard/npt-analysis-field',
    name: 'npt-analysis-field',
    component: () => lazyLoadView(import('@views/dashboard/pt-npt-field')),
    meta: {
      authRequired: true,
      priv: 14,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  // {
  //   path: '/dashboard/drilling-program',
  //   name: 'drilling-program',
  //   redirect: '/dashboard/drilling-program/days-depth-cost'
  // },
  // {
  //   path: '/form',
  //   name: 'form',
  //   redirect: '/form/daily-drilling-report'
  // },
  // {
  //   path: '/dashboard/cost-breakdown',
  //   name: 'cost-breakdown',
  //   redirect: '/dashboard/cost-breakdown/ave-vs-actual'
  // },
  // {
  //   path: '/dashboard/:id',
  //   component: () => lazyLoadView(import('@views/dashboard/well-information')),
  //   children: [{
  //       path: '/dashboard/drilling-program/index',
  //       name: 'drilling-program-index',
  //       component: () => lazyLoadView(import('@views/dashboard/drilling-program/index')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: 'well-information',
  //       name: 'well-information',
  //       component: () => lazyLoadView(import('@views/dashboard/well-information')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/subsurface-summary',
  //       name: 'subsurface-summary',
  //       component: () => lazyLoadView(import('@views/dashboard/subsurface-summary')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/drilling-program/days-depth-cost',
  //       name: 'days-depth-cost',
  //       component: () => lazyLoadView(import(
  //         '@views/dashboard/drilling-program/days-depth-cost')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/drilling-program/npt',
  //       name: 'npt',
  //       component: () => lazyLoadView(import('@views/dashboard/drilling-program/npt')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/drilling-program/days-per-10k',
  //       name: 'days-per-10k',
  //       component: () => lazyLoadView(import('@views/dashboard/drilling-program/days-per-10k')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/drilling-program/bit-performance',
  //       name: 'bit-performance',
  //       component: () => lazyLoadView(import(
  //         '@views/dashboard/drilling-program/bit-performance')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/drilling-program/one-page-drilling-program',
  //       name: 'one-page-drilling-program',
  //       component: () => lazyLoadView(import(
  //         '@views/dashboard/drilling-program/one-page-drilling-program')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/cost-breakdown/afe-vs-actual',
  //       name: 'afe-vs-actual',
  //       component: () => lazyLoadView(import('@views/dashboard/cost-breakdown/afe-vs-actual')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/cost-breakdown/progress-cost',
  //       name: 'progress-cost',
  //       component: () => lazyLoadView(import('@views/dashboard/cost-breakdown/progress-cost')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/cost-breakdown/cum-cost-per-contract-category',
  //       name: 'cum-cost-per-contract-category',
  //       component: () => lazyLoadView(import(
  //         '@views/dashboard/cost-breakdown/cum-cost-per-contract-category')),
  //       meta: {
  //         authRequired: true
  //       }
  //     },
  //     {
  //       path: '/dashboard/cost-breakdown/timeline-progress',
  //       name: 'timeline-progress',
  //       component: () => lazyLoadView(import(
  //         '@views/dashboard/cost-breakdown/timeline-progress')),
  //       meta: {
  //         authRequired: true
  //       }
  //     }
  //   ],
  //   props: (route) => ({
  //     user: store.state.auth.currentUser || {}
  //   })
  // },
    // Consolidated Daily Drilling
    {
      path: '/form/consolidated-daily-drilling-report',
      name: 'form-consolidated-daily-drilling-report',
      component: () =>
        lazyLoadView(import('@views/form/ddr-preview')),
      meta: {
        authRequired: true,
        priv: 10,
      },
    },
  
  {
    path: '/form/daily-drilling-report',
    name: 'form-daily-drilling-report',
    component: () => lazyLoadView(import('@views/form/daily-drilling-report')),
    meta: {
      authRequired: true,
      priv: 10,
    },
  },
  // Drilling Activity
  {
    path: '/form/drilling-activity/kick',
    name: 'form-drilling-activity-kick',
    component: () => lazyLoadView(import('@views/form/drilling-activity/kick')),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  {
    path: '/form/drilling-activity/casing',
    name: 'form-drilling-activity-casing',
    component: () => import('@views/form/drilling-activity/casing'),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  {
    path: '/form/drilling-activity/cement',
    name: 'form-drilling-activity-cement',
    component: () =>
      lazyLoadView(import('@views/form/drilling-activity/cement')),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  {
    path: '/form/drilling-activity/coring',
    name: 'form-drilling-activity-coring',
    component: () =>
      lazyLoadView(import('@views/form/drilling-activity/coring')),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  {
    path: '/form/drilling-activity/logging',
    name: 'form-drilling-activity-logging',
    component: () =>
      lazyLoadView(import('@views/form/drilling-activity/logging')),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  {
    path: '/form/drilling-activity/fishing',
    name: 'form-drilling-activity-fishing',
    component: () =>
      lazyLoadView(import('@views/form/drilling-activity/fishing')),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  {
    path: '/form/drilling-activity/well-test',
    name: 'form-drilling-activity-well-test',
    component: () =>
      lazyLoadView(import('@views/form/drilling-activity/well-test')),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  {
    path: '/form/drilling-activity/general-work',
    name: 'form-drilling-activity-general-work',
    component: () =>
      lazyLoadView(import('@views/form/drilling-activity/general-work')),
    meta: {
      authRequired: true,
      priv: 11,
    },
  },
  // Drilling Activity
  {
    path: '/form/approval-form',
    name: 'approval-form',
    component: () => lazyLoadView(import('@views/form/approval-form')),
    meta: {
      authRequired: true,
      priv: 13,
    },
  },
  /* {
    path: '/form/subsurface-form',
    name: 'subsurface-form',
    component: () => lazyLoadView(import('@views/form/subsurface-form')),
    meta: {
      authRequired: true,
      priv: 12,
    },
  }, */
  // {
  //   path: '/form/planner-form',
  //   name: 'planner-form',
  //   component: () => lazyLoadView(import('@views/form/planner-form')),
  //   meta: {
  //     authRequired: true,
  //     priv: 9
  //   }
  // },
  {
    path: '/form/planner-form',
    name: 'planner-form',
    component: () => lazyLoadView(import('@views/form/planner/planner-form')),
    meta: {
      authRequired: true,
      priv: 9,
    },
  },

  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => lazyLoadView(import('@views/secondStepAuth')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home',
          })
        } else {
          // Continue to the auth page
          next()
        }
      },
    },
  },
  {
    path: '/help',
    name: 'help',
    component: () => lazyLoadView(import('@views/help')),
    meta: {
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (store.getters['auth/loggedIn']) {
      //     // Redirect to the home page instead
      //     next({
      //       name: 'home',
      //     })
      //   } else {
      //     // Continue to the login page
      //     next()
      //   }
      // },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'home',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        
        // Navigate back to previous page, or home as a fallback
         next(
          authRequiredOnPreviousRoute
            ? {
                name: 'home',
              }
            : {
                ...routeFrom,
              }
        ) 
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
